// 入力文字列をキーワードのリストへ分解（カンマ・読点・改行区切り）
export const splitKeywords = (keywords: string): string[] =>
  keywords
    .split(/[,、\n]/)
    .map((k) => k.trim())
    .filter(Boolean)
